export default {
  新增模板: "新增模板",
  供应商类别: "供應商類別",
  考核维度: "考核維度",
  考核項: "考核項",
  请完善模板信息: "請完善模板資訊",
  保存成功: "保存成功",
  更新成功: "更新成功",
  需要至少新增一个考核维度: "需要至少新增一個考核維度",
  "所有考核项的权重总和不能超过100%，当前为{{totalWeight}}%":
    "所有考核項的權重總和不能超過100%，當前為{{totalWeight}}%",
  新增维度: "新增維度",
  "优秀 (100分)": "優秀 (100分)",
  "良好 (75分)": "良好 (75分)",
  "一般 (50分)": "一般 (50分)",
  "差 (25分)": "差 (25分)",
  序号: "序號",
  考核权重: "考核權重",
  考核部门: "考核部門",
  考核等级: "考核等級",
  等级描述: "等級描述",
  操作: "操作",
  必填: "必填",
  输入考核項: "輸入考核項",
  选择部门: "選擇部門",
  请输入等级描述: "請輸入等級描述",
  删除考核項: "刪除考核項",
  "您确定要删除该考核项吗？": "您確定要刪除該考核項嗎？",
  添加: "添加",
  "暂无考核项，请点击下方按钮添加": "暫無考核項，請點擊下方按鈕添加",
  删除成功: "刪除成功",
  确认操作: "確認操作",
  "确认删除该类别吗？": "確認刪除該類別嗎？",
  请输入维度名称: "請輸入維度名稱",
  删除考核维度: "刪除考核維度",
  "您确定要删除该考核维度吗？": "您確定要刪除該考核維度嗎？",
  删除阶段: "刪除階段",
  考核标准: "考核標準",
  等级: "等級",
  描述: "描述",
  考核标准权重: "考核標準權重",
  取消: "取消",
};
